import type { TourDefinition } from '../training/tours';

/**
 * Тур конструктора правил автоматизації. Цілі — атрибути data-tour на розділах конструктора
 * (rule-trigger, rule-conditions, rule-actions, rule-test, rule-save). Зареєстровано в features/training/tours.ts;
 * кнопка «Як це працює» в конструкторі запускає його з тими самими кроками.
 */
export const RULE_BUILDER_TOUR_ID = 'automation-rule-builder';

export const RULE_BUILDER_TOUR: Omit<TourDefinition, 'id'> = {
  title: 'Конструктор правил',
  summary: 'Як скласти правило «тригер → умова → дія», перевірити його на задачі й безпечно зберегти.',
  missingHint: 'Відкрийте конструктор правила (Автоматизація → «Нове правило») — підказки прив’яжуться до його розділів.',
  steps: [
    {
      id: 'trigger',
      target: 'rule-trigger',
      title: 'Коли: тригер',
      body: 'Оберіть подію, на яку реагує правило: створення чи переміщення задачі, наближення строку, прострочення, коментар, подану форму, подію CRM чи Drive або розклад.',
    },
    {
      id: 'conditions',
      target: 'rule-conditions',
      title: 'Якщо: умови',
      body: 'Звузьте, для яких задач спрацьовує правило: поле, оператор, значення. «Усі» — мають виконатися всі умови, «будь-яка» — достатньо однієї. Без умов правило діє на кожну подію тригера.',
    },
    {
      id: 'actions',
      target: 'rule-actions',
      title: 'Що зробити: дії',
      body: 'Дії виконуються по черзі: встановити поле, перемістити, призначити за роллю, додати чек-лист із шаблону, створити задачу, сповістити, запросити дію іншого модуля. Порядок змінюйте перетягуванням.',
    },
    {
      id: 'test',
      target: 'rule-test',
      title: 'Перевірте на задачі',
      body: 'Пробний запуск показує, які умови пройдено й що саме було б змінено, — у системі нічого не змінюється. Тестовий режим правила лише імітує дії й пише результат у журнал.',
    },
    {
      id: 'save',
      target: 'rule-save',
      title: 'Збереження й захист',
      body: 'Під час збереження система перевіряє правило: помилки з’являться біля поля чи дії. Захист від зациклення обмежує повторні запуски, а після серії помилок правило вимкнеться й власник отримає сповіщення.',
    },
  ],
};
